export const LOGOUT = 'logout';
export const LOGIN = 'login';
export const INVITE = 'invite';
export const SWITCH = 'switch_hospital';
export const UPDATE = 'update_user';
